import React from "react";
import { NotificationBell } from "../../notifications/person-notifications.component";
import "./top-bar-row.styles.scss";
export default function TopBarRow({ className = "", children }) {
  return <div className={`appTopBarRow ${className}`}>
    <div className="appTopBarRow__main">{children}</div>
    <div className="appTopBarRow__actions"><NotificationBell /></div>
  </div>;
}
